import { combineReducers, Reducer } from "redux";
import { IPageLayout, PreferenceActions } from "./actions";
export interface IPreferenceState {
  pageLayouts: IPageLayout[];
  savedPageLayout: IPageLayout | null;
}
const initialState: IPreferenceState = {
  pageLayouts: [],
  savedPageLayout: null
};

const pageLayoutsReducer = (state: IPageLayout[] = initialState.pageLayouts, action: PreferenceActions) => {
  switch (action.type) {
    case "LOAD_PAGE_LAYOUTS_SUCCESS":
      return action.payload.layouts;
    case "UPDATE_PAGE_LAYOUT_SUCCESS":
      return state.map((layout: IPageLayout) => {
        if (layout.id === action.payload.layout.id) {
          return action.payload.layout;
        } else {
          return layout;
        }
      });
    case "CREATE_PAGE_LAYOUT_SUCCESS":
      return [...state, action.payload.layout];
    // case "DELETE_PAGE_LAYOUT_SUCCESS":
    //   return state.filter((layout: IPageLayout) => {
    //     return layout.id !== action.payload.layout.id;
    //   });
    default:
      return state;
  }
};

const savedPageLayoutReducer = (state: IPageLayout | null = initialState.savedPageLayout, action: PreferenceActions) => {
  switch (action.type) {
    case "CREATE_PAGE_LAYOUT_SUCCESS":
      return action.payload.layout;
    case "CLEAR_SAVED_PAGE_LAYOUT":
      return initialState.savedPageLayout;
    default:
      return state;
  }  
};

export const preferencesReducer: Reducer<IPreferenceState> = combineReducers<IPreferenceState>({
  pageLayouts: pageLayoutsReducer,
  savedPageLayout: savedPageLayoutReducer
});